import Home from "./pages/Home";
import { CssBaseline, ThemeProvider } from "@mui/material";
import React, { useMemo } from "react";
import { PuffLoader } from "react-spinners";
import axios from "axios";
import theme from "./styles/theme.js";
import { css } from "@emotion/react";
import "animate.css";

import { useAxiosLoader } from "use-axios-loader";
import { useTranslation } from "react-i18next";

const App = () => {
	const { t } = useTranslation();

	const [loading] = useAxiosLoader(axios);

	const puffOverride = useMemo(() => {
		return css`
			position: fixed;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		`;
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<main>
				<PuffLoader
					loading={loading ? true : false}
					css={puffOverride}
					color="#1976d2"
					size={150}
				/>

				{loading && (
					<div className="absolute z-50 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-all delay-300 text-center text-gray-800 font-black pointer-events-none">
						<h2 className="text-4xl uppercase animate__animated animate__bounceOut animate__delay-1s">
							{t("keyword.working")}
						</h2>
					</div>
				)}

				<div
					className="app-outer-wrap"
					style={
						loading
							? {
								position: "relative",
								transition: "all 350ms ease-in-out",
								opacity: "0.6",
								pointerEvents: "none",
								filter: "blur(5px)",
							}
							: {
								position: "relative",
								transition: "all 150ms ease-in-out",
								opacity: "1.0",
								pointerEvents: "inherit",
								filter: "blur(0px)",
							}
					}
				>
					<Home />
				</div>
			</main>
		</ThemeProvider>
	);
};

export default App;
